export default function EventCard({ event, onClick, currentUserId }) {
  const isHost = event.host_id === currentUserId;
  const approved = (event.dishes||[]).filter(d => d.status === 'approved').length;
  const guestCount = (event.event_guests||[]).length + 1;
  const fmtDate = d => new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
  return (
    <div onClick={onClick} style={{borderRadius:18,overflow:'hidden',border:'1px solid #E5D9C8',background:'white',cursor:'pointer',transition:'all .2s'}}
      onMouseEnter={e=>{ e.currentTarget.style.boxShadow='0 4px 20px rgba(44,26,14,.12)'; e.currentTarget.style.transform='translateY(-3px)'; }}
      onMouseLeave={e=>{ e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; }}>
      <div style={{height:110,background:event.banner_bg||'#3E2723',backgroundImage:'radial-gradient(ellipse at 80% 20%,rgba(255,255,255,.07) 0%,transparent 70%)',display:'flex',alignItems:'flex-end',padding:'14px 16px',position:'relative'}}>
        <span style={{fontSize:44}}>{event.emoji}</span>
        {isHost && <span style={{position:'absolute',top:12,right:12,background:'rgba(255,255,255,.2)',color:'white',fontSize:11,padding:'3px 9px',borderRadius:12}}>Hosting</span>}
        {event.status==='past' && <span style={{position:'absolute',top:12,left:12,background:'rgba(0,0,0,.3)',color:'white',fontSize:11,padding:'3px 9px',borderRadius:12}}>Past</span>}
      </div>
      <div style={{padding:16}}>
        <h4 style={{fontFamily:'Cormorant Garamond,serif',fontSize:18,marginBottom:3}}>{event.title}</h4>
        <p style={{fontSize:13,color:'#7A6555',marginBottom:10}}>{fmtDate(event.date)} · {event.time}</p>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          <span style={{display:'inline-block',padding:'3px 10px',borderRadius:12,fontSize:11,background:'#F0EAE0',color:'#7A6555'}}>👥 {guestCount}</span>
          <span style={{display:'inline-block',padding:'3px 10px',borderRadius:12,fontSize:11,background:'#F0EAE0',color:'#7A6555'}}>🍽️ {approved} dishes</span>
        </div>
      </div>
    </div>
  );
}
